const actionTypeIdentifier = '866BA4E8-2DC0-4C64-841D-180F2E7D794A';

export const setCsatQuestions = `SET-CSAT-QUESTIONS-${actionTypeIdentifier}`;
export const setCsatLoading = `SET-CSAT-LOADING-${actionTypeIdentifier}`;
export const setSurveyModel = `SET-SURVEY-MODEL-${actionTypeIdentifier}`;
export const setSurveyComment = `SET-SURVEY-COMMENT-${actionTypeIdentifier}`;
export const setDisableSubmit = `SET-DISABLE-SUBMIT-${actionTypeIdentifier}`;
export const showHideCsatModal = `SHOW-HIDE-CSAT-MODAL-${actionTypeIdentifier}`;
export const showCompletion = `SHOW-CSAT-COMPLETION-${actionTypeIdentifier}`;
export const resetInitialState = `RESET-CSAT-INITIAL-STATE-${actionTypeIdentifier}`;
export const showCSATButton = `SHOW-CSAT-BUTTON-${actionTypeIdentifier}`;
export const setCsatSurvey = `SET-CSAT-SURVEY-${actionTypeIdentifier}`;